export default __webpack_public_path__ + "static/injury-0c89bbdeb923b21e7582ecb974b57c26.jpg";